import { createBrowserRouter, RouteObject } from "react-router-dom";
import { lazy } from "react";
import App from "../components/App/App";
import LandingPage from "../pages/LandingPage/LandingPage";
import StructuresPage from "../pages/StructuresPage/StructuresPage";
import DetailPage from "../pages/DetailPage/DetailPage";

const MapPage = lazy(() => import("../pages/MapPage/MapPage"));

const NotFoundPage = lazy(() => import("../pages/NotFoundPage/NotFoundPage"));

const LoginPage = lazy(() => import("../pages/LoginPage/LoginPage"));
const CreateStructurePage = lazy(
  () => import("../pages/CreateStructurePage/CreateStructurePage")
);
const LoggedRedirects = lazy(
  () => import("../components/LoggedRedirects/LoggedRedirects")
);
const ProtectedRoute = lazy(
  () => import("../components/ProtectedRoute/ProtectedRoute")
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <LandingPage />,
      },
      { path: "/home", element: <StructuresPage /> },
      {
        path: "/login",
        element: (
          <LoggedRedirects>
            <LoginPage />
          </LoggedRedirects>
        ),
      },
      {
        path: "/map",
        element: !process.env.REACT_APP_TEST ? <MapPage /> : <div>DANG</div>,
      },
      {
        path: "/add-new-structure",
        element: (
          <ProtectedRoute>
            <CreateStructurePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/structure/:id",
        element: <DetailPage />,
      },
      {
        path: "/*",
        element: <NotFoundPage />,
      },
    ],
  },
];

const router = createBrowserRouter(routes);

export default router;
